import React from 'react';
import { ApiOutlined, CheckOutlined, PaperClipOutlined } from '@ant-design/icons';
import { normalizeQuickModeKey, resolveQuickModeIcon } from './composerShared.jsx';
import preserveInputFocus from './preserveInputFocus.js';

function buildMenuActions({
  fileInputRef,
  disabled,
  quickModeEntries,
  modeValue,
  onModeChange,
}) {
  const modeEntries = quickModeEntries.filter((entry) => entry.kind === 'mode');
  return [
    {
      key: 'upload',
      label: '附件',
      icon: <PaperClipOutlined />,
      disabled,
      dividerAfter: true,
      onClick: () => fileInputRef.current?.click(),
    },
    ...modeEntries.map((entry) => ({
      key: entry.key,
      label: entry.label,
      icon: resolveQuickModeIcon(entry.key),
      disabled: disabled || typeof onModeChange !== 'function',
      selected: normalizeQuickModeKey(modeValue) === normalizeQuickModeKey(entry.key),
      onClick: () => onModeChange?.(entry.key),
    })),
    {
      key: 'mcp-placeholder',
      label: 'MCP',
      icon: <ApiOutlined />,
      disabled: true,
    },
  ];
}

export default function ComposerActionMenu({
  fileInputRef,
  disabled = false,
  quickModeEntries = [],
  modeValue,
  onModeChange,
  setToolMenuOpen,
}) {
  const menuActions = buildMenuActions({
    fileInputRef,
    disabled,
    quickModeEntries,
    modeValue,
    onModeChange,
  });
  return (
    <div className="flare-composer-menu">
      {menuActions.map((item) => (
        <React.Fragment key={item.key}>
          <button
            aria-pressed={item.selected}
            className={`flare-composer-menu-item${item.selected ? ' is-checked' : ''}`}
            disabled={item.disabled}
            onMouseDown={preserveInputFocus}
            onClick={() => {
              if (item.disabled) return;
              item.onClick?.();
              setToolMenuOpen(false);
            }}
            type="button"
          >
            <span className="flare-composer-menu-item-icon">{item.icon}</span>
            <span>{item.label}</span>
            {item.selected ? <CheckOutlined aria-hidden="true" style={{ marginLeft: 'auto' }} /> : null}
          </button>
          {item.dividerAfter ? <div className="flare-composer-menu-divider" /> : null}
        </React.Fragment>
      ))}
    </div>
  );
}
